import React, { Component } from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { Field, FieldArray } from 'formik'
import get from 'lodash/get'

import Action from '@components/Action'
import { Dropdown } from '@components/Form/Autocomplete'
import DeleteIcon from '@components/Icon/Delete'
import SherlockReason from '@components/SherlockReason'

class ExpertPositionFields extends Component {
  static propTypes = {
    form: PropTypes.object,
    expertListErrors: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    expertListWarnings: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    expertListInviteErrors: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array
    ]),
    isOneExpert: PropTypes.bool
  }

  handlePositionChange = (experience, form, index) => {
    form.setFieldValue(`expertList[${index}].position`, experience, false)
    form.setFieldTouched(`expertList[${index}].position`, true)
  }

  handleDelete = (arrayHelpers, index, expertId) => {
    arrayHelpers.remove(index)

    const { expertListErrors } = this.props
    const { expertListWarnings } = this.props

    const errorIndex = expertListErrors.findIndex(e => e.expertId === expertId)
    expertListErrors.splice(errorIndex, 1)
    this.props.updateErrors(expertListErrors)

    const warningIndex = expertListWarnings.findIndex(w => w.expertId === expertId)
    expertListWarnings.splice(warningIndex, 1)
    this.props.updateWarnings(expertListWarnings)
  }

  render () {
    const {
      form,
      expertListErrors,
      expertListInviteErrors,
      expertListWarnings,
      isOneExpert
    } = this.props

    const formError =
      get(form.touched, 'expertList') && get(form.errors, 'expertList')

    return formError && typeof formError === 'string' ? (
      <div className="red-text">{formError}</div>
    ) : (
      <FieldArray
        name="expertList"
        render={arrayHelpers =>
          (form.values.expertList || []).map((expert, index) => {
            const error =
              expertListErrors &&
              expertListErrors.find(
                ({ expertId }) => expertId === expert.expert.userId
              )
            const inviteError =
              expertListInviteErrors &&
              expertListInviteErrors.find(
                ({ expertId }) => expertId === expert.expert.userId
              )
            const expertDetails = this.props.experts.filter(
              e => e.id === expert.id
            )[0]
            const warning = expertListWarnings &&
              expertListWarnings.find( ({expertId}) => expertId === expert.expert.userId )

            return (
              <div
                className="expert-position-fields expert-form__repeatable-input"
                key={expert.id}>
                <Field
                  key={expert.id}
                  name={`expertList[${index}].position`}
                  label={
                    <div
                      className={`${
                        form.values.expertList.length > 1 &&
                        expertDetails.sherlock?.allowed === false &&
                        !this.props.comments[expertDetails.id]
                          ? 'error'
                          : ''
                      }`}>
                      {`${expert.title || ''} ${expert.fullName}`.trim()}
                      {'     '}
                      {form.values.expertList.length > 1 &&
                      expertDetails.sherlock?.allowed === false ? (
                        <SherlockReason
                          sherlock={
                            this.props.experts.filter(
                              e => e.id === expert.id
                            )[0].sherlock
                          }
                          iconOnly
                        />
                      ) : null}
                    </div>
                  }
                  options={expert.experiences}
                  itemToString={item => item && item.label}
                  onChange={value =>
                    this.handlePositionChange(value, form, index)
                  }
                  component={Dropdown}
                />
                {!isOneExpert && (
                  <Action
                    className="expert-form__repeatable-action--delete"
                    right
                    onClick={() =>
                      this.handleDelete(arrayHelpers, index, expert.id)
                    }>
                    <DeleteIcon blue />
                  </Action>
                )}
                {
                error ? (
                  <div className="red-text">{error.error}</div>
                ) : inviteError ? (
                  <div className="red-text">{inviteError.error}</div>
                ) : null }
                {
                  warning ? (<div className="orange2-text">{warning.warning}</div>) : null
                }
              </div>
            )
          })
        }
      />
    )
  }
}

export default observer(ExpertPositionFields)
